<template>
  <div>
<!--    <v-layout wrap>
      <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
        <v-select
            label="Chọn kiểu tìm kiếm"
            v-validate="'required'"
            :items="lstWarehouse"
            item-text="nameType"
            item-value="idType"
            @change="onChangeWh"
            clearable
        />
      </v-flex>
    </v-layout>-->
    <v-layout wrap>
      <v-flex>
        <v-layout wrap>
          <v-flex xs4 style="padding: 10px">
            <v-select
                label="Chọn kiểu tìm kiếm"
                v-validate="'required'"
                :items="lstWarehouse"
                item-text="nameType"
                item-value="idType"
                @change="onChangeWh"
                clearable
            />
          </v-flex>
          <v-flex xs8 style="padding: 10px">
            <v-layout wrap>
              <v-flex xs6 style="padding-right: 10px">
                <i-datepicker
                    value=""
                    label="Từ ngày"
                    clearable
                    @clearText="clearFromDate"
                    @change="onChangeFromDate"
                />
              </v-flex>
              <v-flex xs6>
                <i-datepicker
                    value=""
                    label="Đến ngày"
                    clearable
                    @clearText="clearToDate"
                    @change="onChangeToDate"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <br>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="id"
            search-url="/pointInfoLog/searchAll"
            form-type="intable"
            ref="tableData"
            :reload="timeReload"
            :accept-create="false"
            :accept-edit="false"
            :accept-delete="false"
            :accept-select="false"
            @viewItem="viewItem"
        >
        </c-search-form>

        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import axios from "axios";

export default {
  name: "warehouse",
  components: {CSearchForm},
  data: () => {
    return {
      item: {
        allTotalActivites: 0,
      },
      formName: "Hoạt động học sinh",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      programName: null,
      lstWarehouse: [],
      idType: null,
      allTotalActivites: 0,
      totalCountLesson: 0,
      totalCountCategory: 0,
      totalCountLiveclass: 0,
      totalCountBabilalaMath: 0,
      hiddenFields: {
        typeId: "0",
        fromDate: null,
        toDate: null,
      },
      fields: [
/*        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },*/

        {
          value: 'currentDate',
          text: 'Day',
          sortable: false,
          search: false,
          width: "15%",
          headerStyle: "text-align:center",
          dateFormat: 'dd/MM/yyyy',
          type:'date',
        },
        {
          value: 'totalActivites',
          text: 'Total activites',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'countLesson',
          text: 'Lesson',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'countLiveclass',
          text: 'Live Class',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'countCategory',
          text: 'Categories',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'countBabilalaMath',
          text: 'Babilala Math',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'allTotalActivites',
          text: 'All Total activites',
          sortable: false,
          search: false,
          width: "7%",
          headerStyle: "text-align:center",
        },
        {
          value: 'totalCountLesson',
          text: 'Total Lesson',
          sortable: false,
          search: false,
          width: "7%",
          headerStyle: "text-align:center",
        },
        {
          value: 'totalCountCategory',
          text: 'Total Category',
          sortable: false,
          search: false,
          width: "7%",
          headerStyle: "text-align:center",
        },
        {
          value: 'totalCountLiveclass',
          text: 'Total Liveclass',
          sortable: false,
          search: false,
          width: "7%",
          headerStyle: "text-align:center",
        },
        {
          value: 'totalCountBabilalaMath',
          text: 'Total BabilalaMath',
          sortable: false,
          search: false,
          width: "7%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    this.getWarehouse();
  },


  methods: {


    onChangeWh(idType) {
      this.hiddenFields = Object.assign(this.hiddenFields, {idType: idType});
    },

    getWarehouse() {
      axios.post(
          process.env.VUE_APP_API_URL +
          "/pointInfoLog/listByType"
      )
          .then((data) => {
            if (data.length > 0) {
              console.info(data)
              this.lstWarehouse = data;
            }
          });
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +


          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },

    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    clearFromDate() {
      this.hiddenFields.fromDate = null;
    },
    clearToDate() {
      this.hiddenFields.toDate = null;
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/tracking/view/' + item.userName,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
